/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Smartlab_Settings_Password_Set_PlaceholderInputs */

const vi_smartlab_settings_password_set_placeholder = /** @type {(inputs: Smartlab_Settings_Password_Set_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Để trống nếu không đổi mật khẩu`)
};

/**

* @param {Smartlab_Settings_Password_Set_PlaceholderInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const smartlab_settings_password_set_placeholder = /** @type {((inputs?: Smartlab_Settings_Password_Set_PlaceholderInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Smartlab_Settings_Password_Set_PlaceholderInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_smartlab_settings_password_set_placeholder(inputs)
});